export const PLAIN_STYLES = {
  notEnoughData: {
    maxWidth: 600,
    margin: '0 auto',
    height: 'calc(100% - 250px)'
  }
};
